import React, {Component} from 'react';
import {connect} from 'react-redux';

import Box from 'components/box';
import Spinner from 'spinner';
import {RecordDetailList} from './record-detail-list';
import {ButtonDefault, ButtonDanger} from 'components/buttons';
import {Actions} from 'components/actions';
import {Divider} from 'components/common';
import Textarea from 'form/textarea';

import {loadRecordDetail, updateRecord} from 'redux/actions/portal/records';

const mapStateToProps = state => ({
  record: state.records.get('recordDetail'),
  user: state.auth.get('user'),
  isFetching: state.records.get('isLoading')
});

const mapDispatchToProps = dispatch => ({
  onLoad: (id) => dispatch(loadRecordDetail(id)),
  updateRecord: (record_id, reception_id, user_id, status, comment) => dispatch(updateRecord(record_id, reception_id, user_id, status, comment))
});

class RecordDetail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      comment: ""
    };
    this.changeComment = this.changeComment.bind(this);
  }

  changeComment(event) {
    this.setState({comment: event.target.value});
  }

  clearComment() {
    this.setState({comment: ""})
  }

  componentDidMount() {
    this.props.onLoad(this.props.match.params.record_id);
  }

  render() {

    if (this.props.record === undefined) {
      return <Spinner/>;
    }

    if (this.props.isFetching) {
      return <Spinner />
    } 

    return(
      <div>
        <Box title3="Інформація про запис до лікаря">
          <RecordDetailList record={this.props.record} />
          <Divider>
            <h4>Коментар реєстратури: {this.props.record.get('comment') ? this.props.record.get('comment') : "Коментар відсутній"}</h4>
          </Divider>
          <Divider>
            <Textarea
              block
              label="Коментар до відповіді"
              value={this.state.comment}
              onChange={this.changeComment}
              placeholder="Введіть коментар до відповіді"
            />
          </Divider>
          <Divider>
            <Actions>
              <li>
                <ButtonDefault onClick={() => {
                  this.props.updateRecord(this.props.record.get('id'), this.props.record.get('reception'), this.props.user.get('id'), 1, this.state.comment)
                  this.clearComment()
                }} value="Прийняти"/>
              </li>
              <li>
                <ButtonDanger onClick={() => {
                  this.props.updateRecord(this.props.record.get('id'), this.props.record.get('reception'), this.props.user.get('id'), 2, this.state.comment)
                  this.clearComment()
                }} value="Відхилити" />
              </li>
            </Actions>
          </Divider>
        </Box>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RecordDetail);



// WEBPACK FOOTER //
// ./src/registry/records/detail.js